import { useEffect, useState } from 'react';

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Fallbacks match the seed defaults so pages render sensibly even if the fetch fails.
const DEFAULTS = {
  business_name: 'Bellarine Tech Assist',
  abn: '51 387 096 106',
  contact_email: 'info@bellarinetechassist.com.au',
};

export function useLegalSettings() {
  const [settings, setSettings] = useState(DEFAULTS);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const resp = await fetch(`${BACKEND}/api/settings/legal`);
        if (resp.ok) {
          const data = await resp.json();
          if (!cancelled && data) {
            setSettings({
              business_name: data.business_name || DEFAULTS.business_name,
              abn: data.abn || DEFAULTS.abn,
              contact_email: data.contact_email || DEFAULTS.contact_email,
            });
          }
        }
      } catch (e) {
        // use defaults
      } finally {
        if (!cancelled) setLoaded(true);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return { ...settings, loaded };
}
